import ActionButton from '../components/ActionButton';
import SubTitle from '../components/SubTitle';
import AlertCardWrapper from '../AlertCardWrapper';
import AlertSwitch from '../components/AlertSwitch';
import AlertPropMixin from './AlertPropMixin';
import AlertNeedActionComputedMixin from './AlertNeedActionComputedMixin';
import { markAlertAsCompleted } from '@/store/modules/alerts/actions';
import { mapActions } from 'vuex';

export default {
	components: { AlertCardWrapper, ActionButton, SubTitle, AlertSwitch },
	mixins: [AlertPropMixin, AlertNeedActionComputedMixin],
	computed: {
		relatedEntitiesMapByEntityType() {
			return this.alert.related_entities_links.reduce((retMap, { entity_id: entityId, entity_type: entityType }) => {
				if (!(entityType in retMap)) {
					retMap[entityType] = [];
				}
				retMap[entityType].push(entityId);
				return retMap;
			}, {});
		},
	},
	methods: {
		...mapActions([markAlertAsCompleted.fullPath]),
		// used when the only action required by user is on client -- otherwise server won't allow it
		async markAlertAsCompleted() {
			await this[markAlertAsCompleted.fullPath]({ id: this.alert.id });
		},
	},
};
